function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#040006;stroke-linecap:round;stroke-width:23.21px;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "IconAcuerdos");

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 85.24,
  y1: 306.55,
  x2: 118.39,
  y2: 339.71
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M281.79,452s62.52,38.37,81,0c0,0,25.58,5.68,34.11-9.94s-1.66-25.82-1.66-25.82,28.65,14.92,40-3.55-.47-30.31-.47-30.31,22.26,13.26,37.41-1.9-6.63-36.94-6.63-36.94L306,232.67s-24.63-7.58-34.58,8.53-36,54.94-78.15,29.36l46.42-76.73s17.05-24.15,69.15-20.36,113.2,20.36,133.56,8.05"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 468.88,
  y1: 346.82,
  x2: 512.92,
  y2: 308.92
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 434.78,
  y1: 382.34,
  x2: 353.31,
  y2: 328.82
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 395.23,
  y1: 416.2,
  x2: 325.37,
  y2: 372.86
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 362.78,
  y1: 451.96,
  x2: 301.68,
  y2: 411.23
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M146,381.42a23.38,23.38,0,0,1-33-.05h0a23.37,23.37,0,0,1,0-33L126.3,335a23.37,23.37,0,0,1,33.05.05h0a23.36,23.36,0,0,1,0,33Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M264.78,468.91a24.53,24.53,0,0,1-34.68,0h0a24.53,24.53,0,0,1,.05-34.67l14-14a24.52,24.52,0,0,1,34.67,0h0a24.53,24.53,0,0,1,0,34.68Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M186.45,414.1a25.94,25.94,0,0,1-36.68-.05h0a25.93,25.93,0,0,1,0-36.67l22.94-22.92a25.94,25.94,0,0,1,36.68.05h0a25.93,25.93,0,0,1,0,36.68Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M218.49,445.85a22.56,22.56,0,0,1-31.89,0h0a22.55,22.55,0,0,1,0-31.89l29-29a22.55,22.55,0,0,1,31.89,0h0a22.56,22.56,0,0,1,0,31.89Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M74.5,322.6a3.75,3.75,0,0,1-5.19,1.1L13.86,288.51a3.74,3.74,0,0,1-1.21-5.16L112.74,125.63a3.75,3.75,0,0,1,5.19-1.1l55.45,35.19a3.76,3.76,0,0,1,1.21,5.17Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M522.3,326.68a3.75,3.75,0,0,0,5.07,1.55L585.69,298a3.75,3.75,0,0,0,1.66-5l-85.9-165.87a3.74,3.74,0,0,0-5.07-1.55l-58.32,30.2a3.75,3.75,0,0,0-1.66,5Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M234.26,202.73s-41.37,2.84-71-19.92"
});

var SvgIconAcuerdos = function SvgIconAcuerdos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAcuerdos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconAcuerdos.a48bb714.svg";
export { ForwardRef as ReactComponent };